import { render, staticRenderFns } from "./CofocusLogo.vue?vue&type=template&id=1a13680d&scoped=true&"
import script from "./CofocusLogo.vue?vue&type=script&lang=js&"
export * from "./CofocusLogo.vue?vue&type=script&lang=js&"
import style0 from "./CofocusLogo.vue?vue&type=style&index=0&id=1a13680d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a13680d",
  null
  
)

export default component.exports